//  this cannot be imported from dependencies
import { graphql, useStaticQuery } from 'gatsby';

import type { MessageDescriptor } from 'react-intl';
import React from 'react';

import { FormattedMessage } from 'react-intl';
import * as felaRules from './Image.styles';
import { TextTypes, Text } from '../../../ui';
import Profile from '../Profile';
import { useIntl } from 'react-intl';
import Img from '../../../../components/Img';
import { useFelaEnhanced } from '@ackee/fela';

export type ImagePropTypes = {
    styles: Record<string, string>;
    alt: MessageDescriptor['id'];
    src: string;
    className?: string;
    overlayColor?: string;
    hideOverlayText?: boolean;
    caseId: string;
    profilePic: string;
    hideProfile?: boolean
};

const Image = ({ styles, src, alt, className = '', overlayColor, hideOverlayText = false, caseId, profilePic, hideProfile}: ImagePropTypes) => {
    const { formatMessage } = useIntl();
    const imageAlt = formatMessage({ id: alt });
    const { rules } = useFelaEnhanced(felaRules, { overlayColor });

    const images = useStaticQuery(graphql`
        query {
            allFile(filter: { relativeDirectory: { eq: "references/items" } }) {
                nodes {
                    base
                    relativePath
                    childImageSharp {
                        fluid(quality: 90, cropFocus: SOUTHWEST, maxWidth: 1520) {
                            ...GatsbyImageSharpFluid_withWebp_tracedSVG
                        }
                    }
                }
            }
        }
    `);

    const match = React.useMemo(
        () => images.allFile.nodes.find(({ relativePath }: { relativePath: string }) =>  src === relativePath),
        [images, src],
    );

    const {
        childImageSharp: { fluid },
    } = match;

    return (
        <div className={`${styles.container} ${className}`} style={{ position: 'relative' }}>
            <Img style={{ transition: 'transform .4s ease' }} alt={imageAlt} fluid={fluid} className={className} />
            {!hideOverlayText ? (
                <div className={styles.overlayTextContainer} >
                    <div className={styles.quotes}>
                    {!hideProfile && <svg xmlns="http://www.w3.org/2000/svg" width="30" height="24" viewBox="0 0 30 24" fill="none" className='testimonialQuotes'>
                            <path d="M30 24V0H18V18H24V24H30ZM12 24V0H0V18H6V24H12Z" fill="white" />
                        </svg> }
                    </div>
                    <div className={`${styles.testimonial} testimonial`} >
                        {!hideProfile ? 
                        <div className='testimonialTxt'>
                        <div className={styles.testimonialText}>
                            {/* @ts-expect-error */}
                            <Text type={TextTypes.PARAGRAPH}>
                                {/* @ts-expect-error */}
                                <FormattedMessage id={`homepage.caseStudies.${caseId}.reference.content`} />
                            </Text>
                        </div>

                        {/* @ts-expect-error */}
                        {caseId ? <Profile image={profilePic} caseId={caseId} /> : null}
                        </div>
                        : null}

                        <div className={styles.cta}>
                            <FormattedMessage id={'homepage.caseStudies.visitCase.tooltip'} />
                        </div>
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default Image;
